enum ESearchType {
    TEST = "Test Search",
    HOTEL = "Hotel Search", 
    REGION = "Region Search", 
    FREEFORM = "Freeform Search",
    LANDMARK = "Landmark Search", 
    CITY = "City Search",
    COUNTRY = "Country Search"
  }
  
  export default ESearchType;
  